import { LoginCard } from '~/ComponentsTW/layout/login-card';
import { Button, Form, FormInput, FormLabel, StandaloneLink } from '~/ComponentsTW/wm';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { apiRequest } from 'utils/request';

export function ForgotPassword({ loginEmail, onAlert, backToLogin }) {
    const
        [email, setEmail] = useState(loginEmail),
        [formFilled, setFormFilled] = useState(false),
        [loading, setLoading] = useState(false);

    useEffect(() => {
        setFormFilled(email !== '');
    }, [email]);

    const handleSubmit = async event => {
        event.preventDefault();
        setLoading(true);

        const data = {
            email
        };

        try {
            const response = await apiRequest('/reset_password', 'POST', data);

            if (response.status === 201) {
                onAlert('If the provided email is associated with a WiseMetering account, you will receive an email with instructions to reset your password.', 'success', 'Success');
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error || 'An error occurred';

            onAlert(errorMessage, 'destructive', 'Failed');
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    return (
        <LoginCard>
            <Form>
                <FormLabel htmlFor="email">enter your email to reset your password</FormLabel>
                <FormInput
                    id="email"
                    onChange={e => setEmail(e.target.value)}
                    placeholder="m@example.com"
                    required
                    type="email"
                    value={email}
                />
                <Button className="tw-w-full" disabled={!formFilled} loading={loading} onClick={handleSubmit} type="submit" variant="secondary">
                    Reset my password
                </Button>
            </Form>
            <StandaloneLink icon="arrowLeftCircle" onAction={backToLogin} text="Back to Login"/>
        </LoginCard>
    );
}
